// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__ErODs","log":"ModalInventoryLogs_log__1b9m9","date":"ModalInventoryLogs_date__IiL3c","userName":"ModalInventoryLogs_userName__ULdMt"};